import React, { Component } from "react";
import { Redirect } from "react-router";

import Container from "react-bootstrap/Container";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faFileAudio, faFolder } from "@fortawesome/free-solid-svg-icons";

import Pagination from "./common/pagination";
import { search } from "../utils/search";
import { paginate } from "../utils/paginate";

import * as FileService from "../services/fileService";
import { isAdmin } from "../services/authService";

import FileAddFormModal from "./fileAddFormModal";

import FilesTable from "./filesTable";

import ConfirmationModalContextProvider from "./common/modalConfirmationContext";

import _ from "lodash";
import SearchBox from "./common/searchBox";

class Files extends Component {
  state = {
    files: [],
    pageSize: 10,
    currentPage: 1,
    sortColumn: { path: "name", order: "asc" },
    searchQuery: "",
    fileAddFormModal: false,
    selectedTab: "announcements",
  };

  async componentDidMount() {
    try {
      const { data: files } = await FileService.getAll();
      this.setState({ files });
    } catch (err) {
      toast.error("Błąd serwera!!!");
      this.props.history.push("/not-found");
    }
  }

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleSort = (sortColumn) => {
    if (sortColumn.path === "") return;

    this.setState({ sortColumn });
  };

  getPagedData = () => {
    const { pageSize, currentPage, files: allFiles, sortColumn, searchQuery } = this.state;

    let filtered = allFiles;

    filtered = allFiles.filter((f) => {
      if (this.state.selectedTab === f.type) return true;

      // Wyjątek dla konieczności kompatybilności wstecznej
      if (this.state.selectedTab === "announcements") {
        if (f.type === null || f.type === undefined) return true;
      }
      return false;
    });

    if (searchQuery) {
      filtered = search(filtered, ["name", "info"], searchQuery);
    }

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const shops = paginate(sorted, currentPage, pageSize);

    return { totalCount: filtered.length, data: shops };
  };

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      selectedDevType: null,
      currentPage: 1,
    });
  };

  handleDeleteFile = async (file) => {
    const _id = file._id;

    try {
      const { data: removedFile } = await FileService.remove(_id);
      if (removedFile) {
        toast.success("Plik został usunięty!");
      }

      const { data: files } = await FileService.getAll();

      this.setState({ files });
    } catch (ex) {
      console.log(ex);
      if (ex.response && ex.response.status === 400) {
        toast.error("Błąd!");
      } else {
        toast.error("Błąd po stronie serwera!");
      }
    }
  };

  handleAddFile = () => {
    this.setState({ fileAddFormModal: true });
  };

  handleFormHide = async () => {
    this.setState({ fileAddFormModal: false });

    const { data: files } = await FileService.getAll();

    this.setState({ files });
  };

  render() {
    const count = this.state.files.length;

    if (!isAdmin()) return <Redirect to="/shops" />;

    const { pageSize, currentPage, sortColumn, searchQuery, fileAddFormModal } = this.state;

    const { totalCount, data: files } = this.getPagedData();

    return (
      <React.Fragment>
        <ConfirmationModalContextProvider>
          {/* Enhanced Breadcrumb */}
          <Breadcrumb style={{ backgroundColor: "#DDDDDD" }}>
            <Breadcrumb.Item
              style={{ marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0 }}
              href="/"
            >
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item
              style={{ marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0 }}
              active
            >
              Konfiguracja
            </Breadcrumb.Item>
            <Breadcrumb.Item
              style={{ marginTop: 3, marginLeft: 3, marginBottom: 3, marginRight: 0 }}
              active
            >
              Zarządzanie plikami mp3
            </Breadcrumb.Item>
          </Breadcrumb>

          <Container
            fluid
            className="px-4"
          >
            {/* Controls Section */}
            <Tabs
              activeKey={this.state.selectedTab}
              id="uncontrolled-tab-example"
              className="minimal-tabs custom-tab minimal-tabs-compact mb-3"
              fill
              onSelect={(tab) => {
                this.setState({ selectedTab: tab, searchQuery: "" });
              }}
            >
              <Tab
                eventKey="announcements"
                title="Komunikaty"
              >
                <div className="minimal-tab-content">
                  <Row className="mb-4">
                    <Col>
                      <Card className="clean-card">
                        <Card.Body className="p-3">
                          <Row className="align-items-center g-3">
                            {isAdmin() && (
                              <Col
                                md={6}
                                lg={2}
                              >
                                <Button
                                  onClick={this.handleAddFile}
                                  variant="primary"
                                  className="minimal-button w-100"
                                >
                                  <FontAwesomeIcon
                                    icon={faPlus}
                                    className="me-2"
                                  />
                                  Dodaj plik
                                </Button>
                              </Col>
                            )}
                            <Col
                              md={6}
                              lg={10}
                            >
                              <SearchBox
                                value={searchQuery}
                                onChange={this.handleSearch}
                                className="search-input-minimal"
                                placeholder="Szukaj plików..."
                              />
                              {searchQuery && (
                                <small className="text-count mt-1 d-block">
                                  Znaleziono {totalCount} z {count} plików
                                </small>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  {/* Files Table Section */}
                  <Row className="mb-4">
                    <Col>
                      <Card className="clean-card">
                        <Card.Header className="bg-light border-bottom p-3">
                          <Row className="align-items-center">
                            <Col>
                              <h6 className="mb-0 fw-medium">Lista plików MP3</h6>
                            </Col>
                            <Col xs="auto">
                              <Badge
                                bg="secondary"
                                className="px-2 py-1"
                              >
                                {totalCount}
                              </Badge>
                            </Col>
                          </Row>
                        </Card.Header>
                        <Card.Body className="p-0">
                          <FilesTable
                            files={files}
                            sortColumn={sortColumn}
                            onDelete={this.handleDeleteFile}
                            onAdd={this.handleAdd}
                            onSort={this.handleSort}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  {/* Pagination Section */}
                  {totalCount > pageSize && (
                    <Row className="mb-4">
                      <Col className="d-flex justify-content-center">
                        <Pagination
                          itemsCount={totalCount}
                          pageSize={pageSize}
                          currentPage={currentPage}
                          onPageChange={this.handlePageChange}
                        />
                      </Col>
                    </Row>
                  )}
                </div>
              </Tab>
              {/* Komunikaty z numerem kasy */}
              <Tab
                eventKey="announcements_cash_no"
                title="Numery kas"
              >
                <div className="minimal-tab-content">
                  <Row className="mb-4">
                    <Col>
                      <Card className="clean-card">
                        <Card.Body className="p-3">
                          <Row className="align-items-center g-3">
                            {isAdmin() && (
                              <Col
                                md={6}
                                lg={2}
                              >
                                <Button
                                  onClick={this.handleAddFile}
                                  variant="primary"
                                  className="minimal-button w-100"
                                >
                                  <FontAwesomeIcon
                                    icon={faPlus}
                                    className="me-2"
                                  />
                                  Dodaj plik
                                </Button>
                              </Col>
                            )}
                            <Col
                              md={6}
                              lg={10}
                            >
                              <SearchBox
                                value={searchQuery}
                                onChange={this.handleSearch}
                                className="search-input-minimal"
                                placeholder="Szukaj plików..."
                              />
                              {searchQuery && (
                                <small className="text-count mt-1 d-block">
                                  Znaleziono {totalCount} z {count} plików
                                </small>
                              )}
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  {/* Files Table Section */}
                  <Row className="mb-4">
                    <Col>
                      <Card className="clean-card">
                        <Card.Header className="bg-light border-bottom p-3">
                          <Row className="align-items-center">
                            <Col>
                              <h6 className="mb-0 fw-medium">Lista plików MP3</h6>
                            </Col>
                            <Col xs="auto">
                              <Badge
                                bg="secondary"
                                className="px-2 py-1"
                              >
                                {totalCount}
                              </Badge>
                            </Col>
                          </Row>
                        </Card.Header>
                        <Card.Body className="p-0">
                          <FilesTable
                            files={files}
                            sortColumn={sortColumn}
                            onDelete={this.handleDeleteFile}
                            onAdd={this.handleAdd}
                            onSort={this.handleSort}
                          />
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  {/* Pagination Section */}
                  {totalCount > pageSize && (
                    <Row className="mb-4">
                      <Col className="d-flex justify-content-center">
                        <Pagination
                          itemsCount={totalCount}
                          pageSize={pageSize}
                          currentPage={currentPage}
                          onPageChange={this.handlePageChange}
                        />
                      </Col>
                    </Row>
                  )}
                </div>
              </Tab>
            </Tabs>

            {isAdmin() && (
              <FileAddFormModal
                show={fileAddFormModal}
                onHide={this.handleFormHide}
                type={this.state.selectedTab}
              />
            )}
          </Container>
        </ConfirmationModalContextProvider>
      </React.Fragment>
    );
  }
}

export default Files;
